<template>

    <div class="settings__item data-card block">
        <div class="data-card__head">
            <div class="data-card__title">
                <span class="data-card__label">Дополнительный сотовый телефон:</span>
                <span class="data-card__value">{{currentPhoneNumber}}</span>
            </div>
            <div class="data-card__link">
                <a href="#dataCard_41" class="link link--present" data-toggle="collapse"><span class="link__text">Изменить</span></a>
            </div>
        </div>
        <div id="dataCard_41" class="data-card__form accordion-body collapse">
            <div class="data-card__inner accordion-body__inner">
                <div class="b-form-sm">
                    <div class="b-form-sm__body">
                        <div class="b-form-sm__item">
                            <label class="txt-input">
                                <div class="txt-input__input">
                                    <masked-input type="text" class="txt-input__field input req"
                                                  :class="$v.newPhoneNumberForApi.$invalid ? 'is-error' : ''"
                                                  v-model="newPhoneMasked"
                                                  :placeholder="currentPhoneNumber ? currentPhoneNumber : 'Дополнительный телефон'"
                                                  :mask="phoneMask"
                                                  placeholderChar="_" />
                                </div>
                            </label>
                        </div>
                        <div class="b-form-sm__item">
                            <a class="button button--th-second"
                               :class="$v.newPhoneNumberForApi.$invalid || isEqualUserData ? 'disabled' : ''"
                               v-on:click="changeExtraPhone">Сохранить</a>
                            <a href="#dataCard_41" class="button button--th-link" data-toggle="collapse">Отменить</a>
                        </div>
                    </div>
                </div>

                <div class="txt-input__required txt-input__required--error error-block">{{validatePhoneTypeText}}</div>

                <div class="txt-input__required" :class="isValidateErrors ? 'error-block' : 'validated-block'">{{serverResponseText}}</div>

                <div class="data-card__caption validated-block">
                    Данный телефон будет отображаться во всех полях для быстрого ввода - в формах ЕПП где потребуется телефон: Заявка, Задать вопрос и т.д.
                </div>

            </div>
        </div>

    </div>

</template>

<script>

    import MaskedInput from 'vue-masked-input';
    import { formatToMobileNumber, formatMobileNumberToDigits } from '../../../../wwwroot/app/epp.utils';

    const { required, minLength } = window.validators
    const { validationMixin } = window.vuelidate

    export default {
        mixins: [validationMixin],
        props: ['user'],
        components: {
            'masked-input': MaskedInput
        },
        data: function () {
            return {
                newPhoneMasked: '',
                isServerVerify: false,
                isValidateErrors: false,
                serverMessage: [],
                serverResponse: '',
                phoneMask: {
                    pattern: '\+7-w11-111-1111',
                    formatCharacters: {
                        'w': {
                            validate: function (char) { return /\9/.test(char) },
                            transform: function (char) { return char.toLowerCase() }
                        }
                    }
                }
            }
        },
        created: function () {
            this.newPhoneMasked = this.currentPhoneNumber;
        },
        computed: {
            currentPhoneNumber: function () {
                return formatToMobileNumber(this.user.ExtraPhone) ? formatToMobileNumber(this.user.ExtraPhone) : this.user.ExtraPhone;
            },
            newPhoneNumberForApi: function () {
                return formatMobileNumberToDigits(this.newPhoneMasked) ? formatMobileNumberToDigits(this.newPhoneMasked) : null;
            },
            validatePhoneTypeText: function () {
                return this.$v.newPhoneNumberForApi.$invalid && (this.newPhoneMasked != '') ? 'Номер телефона должен содержать 10 цифр' : ' ';
            },
            serverResponseText: function () {
                return this.serverMessage ? this.serverMessage[0] : '';
            },
            isEqualUserData: function () {
                return this.newPhoneMasked == this.currentPhoneNumber;
            }
        },
        watch: {
            newPhoneMasked: function () {
                if (this.newPhoneMasked.length >= 1) {
                    this.serverMessage = [];
                    this.isServerVerify = false;
                }
            },
            isValidateErrors: function (isValidateErrors) {
                if (!isValidateErrors) {
                    this.serverMessage = [];
                }
            },
            serverResponse: function (serverResponse) {
                this.serverMessage = this.serverResponse.message;

                if (serverResponse.isSuccess) {
                    this.updateUserExtraPhone(this.newPhoneNumberForApi);
                    this.isValidateErrors = false;
                    this.isServerVerify = true;
                } else {
                    this.isValidateErrors = true;
                    this.isServerVerify = false;
                }
            }
        },
        validations: {
            newPhoneNumberForApi: {
                required: required,
                minLength: minLength(11)
            }
        },
        methods: {
            changeExtraPhone: function () {
                var self = this;
                this.isValidateErrors = false;

                axios.post('/Profiles/ChangeExtraPhone', {
                    CurrentUserName: self.user.UserName,
                    ExtraPhone: self.newPhoneNumberForApi,
                })
                    .then(function (response) {
                        self.serverResponse = response.data;
                        document.querySelector('html').classList.remove('is-lock');
                    })
                    .catch(function (error) {
                        console.log(error)
                        self.isValidateErrors = true;
                        self.serverMessage = ['Изменение номера телефона невозможно, попробуйте позже']
                    });
            },
            updateUserExtraPhone: function (newPhoneNumberForApi) {
                this.$emit('update', newPhoneNumberForApi);
                this.isValidateErrors = false;
                this.serverMessage = ['Номер телефона успешно сохранен']
            }
        }
    }

</script>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/ChangeExtraPhone.vue